
import { useState } from 'react';
import ConsultationModal from './ConsultationModal';

export default function HeroSection() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/28930105bf5165772cb9df9c3b29d420.png')`
      }}
    >
      <div className="w-full max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
            한일연애<br />
            <span className="text-blue-300">세계에서 유일한</span><br />
            반주지원.
          </h1>
          
          <p className="text-xl md:text-2xl lg:text-3xl mb-8 font-medium text-white">
            1000명이상의 일본인여성의 연애를 지원해 알게 된 "그녀들의 속마음", 당신에게 전합니다.
          </p>
          
          <div className="mb-12 max-w-4xl mx-auto">
            <div className="grid md:grid-cols-3 gap-6 text-center">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-global-line text-3xl text-blue-300"></i>
                </div>
                <h3 className="font-semibold mb-2">한일연애전문</h3>
                <p className="text-sm text-white">전 팀 멤버 일본인여성+한일연애경험자</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-message-3-line text-3xl text-blue-300"></i>
                </div>
                <h3 className="font-semibold mb-2">언어장벽완전해결</h3>
                <p className="text-sm text-white">한국어＋일본어완벽대응</p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center">
                  <i className="ri-time-line text-3xl text-blue-300"></i>
                </div>
                <h3 className="font-semibold mb-2">24시간동반지원</h3>
                <p className="text-sm text-white">주1회미팅＋실시간피드백</p>
              </div>
            </div>
          </div>

          <a
            href="https://lin.ee/YbXV7uH"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white text-sm md:text-xl font-bold px-4 py-3 md:px-12 md:py-4 rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
          >
            무료카운슬링을 지금예약하기
          </a>
          
          <p className="mt-4 text-sm text-white">
            ✓ 약 1시간의 무료 상담 ✓ 개인별맞춤분석 ✓ 즉시예약가능
          </p>
        </div>
      </div>
      
      <ConsultationModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
}
